var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDownWhiteDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6159 14.5391L9.18691 11.6243C8.24083 10.489 7.76779 9.92135 7.98356 9.46068C8.19933 9 8.93824 9 10.4161 9L13.5839 9C15.0618 9 15.8007 9 16.0164 9.46068C16.2322 9.92135 15.7592 10.489 14.8131 11.6243L14.8131 11.6243L12.3841 14.5391C12.2061 14.7527 12.1171 14.8595 12 14.8595C11.8829 14.8595 11.7939 14.7527 11.6159 14.5391Z",
    fill: "#F6F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownWhiteDarkMode);
export default __webpack_public_path__ + "static/media/Arrow_drop_down_white_dark_mode.aa5d8856fb1ab4bce9c310136f524be9.svg";
export { ForwardRef as ReactComponent };